import { StrictMode } from "react"

import { QueryClientProvider } from "@tanstack/react-query"
import { IDirective } from "angular"
import { createRoot } from "react-dom/client"

import { queryClient } from "@/query/queryClient"

import { StudentProfile } from "./StudentProfile"
import { StudentProfileController } from "./StudentProfile.controller"

export function StudentProfileDirective(): IDirective {
  return {
    restrict: "E",
    controller: "StudentProfileController",
    link: function (scope, element, _attributes, controller) {
      const root = createRoot(element[0])

      root.render(
        <StrictMode>
          <QueryClientProvider client={queryClient}>
            <StudentProfile
              controller={controller as StudentProfileController}
            />
          </QueryClientProvider>
        </StrictMode>,
      )

      scope.$on("$destroy", () => {
        root.unmount()
      })
    },
  }
}
